import {getRecaptchaToken, preloadGoogleRecaptcha, Http, Utils} from "../src/utils";

const REQ_FAIL_MSG = 'We are sorry but something goes wrong while processing your request. Please try again later or <a href="/contact">contact us</a> directly by email, phone or live chat.';
const VAL_FAIL_MSG = 'Please fill out all highlighted fields.';
// const CAPTCHA_FAIL_MSG = 'Captcha check expired please resubmit the form again';
const CAPTCHA_LOAD_MSG = 'Captcha loading error. Please reload the page and try again';
const errBorder = '1px solid red';

export const initRMA = () => {
    const messageBox = document.querySelector('#rfq-message-box');
    const formEl = document.querySelector('#rmaForm');
    const loader = formEl.querySelector('#loading-rma');
    const optionsBox = formEl.querySelector('#option-list');
    const rmaType = Array.from(formEl.querySelectorAll('input[name="rma_type"]'));
    const rmaRow = formEl.querySelector('.rma-type-row');
    const mainFields = [
        formEl.querySelector('input[name="name"]'),
        formEl.querySelector('textarea[name="description"]'),
        formEl.querySelector('input[name="phone"]'),
        formEl.querySelector('input[name="email"]'),
        formEl.querySelector('input[name="contact"]'),
    ]
    let newCsrf = false;
    let submitted = false;
    let formInProgress = false;
    // let checkRecaptchaHandler;
    // let recaptcha;

    /**
     * Init
     */
    const init = () => {
        // const siteKey = formEl.querySelector('input[name=site_key]').value;

        // recaptcha = GoogleItcRecaptcha.getInstance({
        //     "sitekey": siteKey,
        //     "callback": captchaSuccess,
        //     "error-callback": showRecaptchaError,
        //     "expired-callback": showRecaptchaExpiredError,
        //     loadError: () => showMessage(CAPTCHA_LOAD_MSG, 'error')
        // });

        optionsInit();
        formInit();
    }

    /**
     *
     */
    const optionsInit = () => {
        const plusEl = formEl.querySelector('#rma-plus');
        const firstRow = optionsBox.querySelector('.option-row');

        plusEl.addEventListener('click', () => {
            const clonedRow = firstRow.cloneNode(true);
            const fields = Array.from(clonedRow.querySelectorAll('input'));

            clonedRow.classList.add('hide-row');
            fields.forEach(el => el.value = '');

            onBlurInit(fields);
            initRemoveOption(clonedRow);
            optionsBox.append(clonedRow)
            setTimeout(() => clonedRow.classList.remove('hide-row'), 10);
        });

        initRemoveOption(firstRow);
    }

    /**
     *
     * @param rowEl
     */
    const initRemoveOption = (rowEl) => {
        rowEl.addEventListener('click', e => {
            const target = e.target.classList.contains('icon') ? e.target.parentNode : e.target;

            if (target.classList.contains('btn-delete')) {
                const parent = target.parentNode;

                parent.classList.add('hide-row');
                setTimeout(() => parent.remove(), 500);
                checkValidity([]);
            }
        });

        const fields = Array.from(rowEl.querySelectorAll('input'));

        onBlurInit(fields);

        rmaType.forEach(el => {
            el.addEventListener('change', () => checkValidity([]))
        })
    }

    /**
     *
     * @param event
     * @param fields
     */
    const onSubmit = async (event, fields) => {
        event.preventDefault();
        submitted = true;

        if (formInProgress) {
            return
        }

        const options = [];
        getOptionsFields().forEach(row => options.push(...row))

        const invalidField = checkValidity(fields.concat(options));

        if (!invalidField) {
            showLoading(true);

            try {
                // await recaptcha.execute();
                // initCheckIframe(checkRecaptchaHandler, () => hideLoading());

                const token = await getRecaptchaToken('rmaForm');
                await captchaSuccess(token);
            } catch (e) {
                hideLoading();
                showMessage(CAPTCHA_LOAD_MSG, 'error');
            }

        } else {
            invalidField.scrollIntoView({block: "center", behavior: "smooth"});
            invalidField.focus && setTimeout(() => invalidField.focus(), 500);
        }
    }


    /**
     *
     */
    const formInit = () => {
        formEl.addEventListener('submit',  (event) => {
            onSubmit(event, mainFields);
        });

        onBlurInitOnce(mainFields);
    }


    /**
     *
     * @param token
     */
    const captchaSuccess = (token) => {
        if (!token) {
            showError()
            return
        }
        showLoading(true);

        const formData = getRequestData(token);

        Http.postJson(formEl.action, formData)
            .then(res => {
                hideLoading();
                if (res && res.status === 'success') {
                    // hideForm();
                    showMessage(res.message, res.status);
                    formEl.querySelector('#rmaSubmit').remove();
                } else {
                    if (res && res.message.includes('CSRF')) {
                        updateCsrfAndSubmitOnce();
                    } else {
                        showError();
                    }
                }
            })
            .catch(showError)
            // .finally(() => recaptcha.reset());
    }

    /**
     * updateCsrfAndSubmitOnce
     */
    let updateCsrfAndSubmitOnce = () => {
        Http.get(location.href)
            .then(r => r.text())
            .then(html => {
                newCsrf = Http.getCsrFromHtml(html);

                if (newCsrf) {
                    formInProgress = false;
                    formEl.querySelector('input[name=_token]').value = newCsrf;
                    onSubmit({preventDefault: () => {}}, mainFields);
                    updateCsrfAndSubmitOnce = showError;
                }
            })
            .catch(showError);
    }


    /**
     *
     * @param token
     * @returns {{}}
     */
    const getRequestData = (token) => {
        const data = {};

        mainFields.forEach(el => data[el.name] = el.value);

        const options = [];

        getOptionsFields().forEach(row => {
            const rowData = {};

            row.forEach(field => {
                rowData[field.name] = field.value;
            });

            options.push(rowData);
        });

        data['options'] = options;
        data['rmaType'] = rmaType.find(el => el.checked).value;
        data['company'] = formEl.querySelector('input[name="company"]').value;
        data['isShippingIssue'] = formEl.querySelector('input[name="isShippingIssue"]').checked;
        data['isEvidenceOrDamage'] = formEl.querySelector('input[name="isEvidenceOrDamage"]').checked;
        data['g-recaptcha-response'] = token;

        return data;
    }


    /**
     *
     * @param {HTMLInputElement[]} fields
     */
    const onBlurInit = (fields) => {

        fields.forEach(el => {
            el.addEventListener('input', () => checkValidity(fields));
        });
    }

    /**
     *
     * @param fields
     */
    let onBlurInitOnce = (fields) => {
        fields.forEach(el => {
            el.addEventListener('input', () => {
                preloadGoogleRecaptcha();

                if (submitted) {
                    checkValidity(fields)
                }
            });
        });

        onBlurInitOnce = () => {};
    }

    /**
     *
     * @returns {HTMLInputElement[][]}
     */
    const getOptionsFields = () => {
        const rows = optionsBox.querySelectorAll('.option-row');

        const res = Array.from(rows).map(row => row.querySelectorAll('input'));

        return res
    }

    /**
     *
     * @param {boolean} state
     */
    const showLoading = (state) => {
        const f = state ? 'add' : 'remove';

        loader.classList[f]('show');
        formInProgress = state;
        // clearInterval(checkRecaptchaHandler);
    }
    const hideLoading = () => showLoading(false);

    /**
     *
     */
    const showError = () => {
        hideLoading();
        showMessage(REQ_FAIL_MSG, 'error');
    }
    // const showRecaptchaError = () => {
    //     hideLoading();
    //     showMessage('Google Recaptcha error!', 'error');
    // }
    // const showRecaptchaExpiredError = () => {
    //     hideLoading();
    //     showMessage(CAPTCHA_FAIL_MSG, 'error');
    // }

    /**
     *
     * @param {HTMLInputElement[]} fields
     * @returns {HTMLInputElement | undefined}
     */
    const checkValidity = (fields) => {
        let errField;

        if (!submitted) {
            return
        }

        fields.forEach(field => {
            const val = field.value;
            let _hasError;

            if (field.type === 'email' && !Utils.validEmail(val)) {
                showFieldError(field, VAL_FAIL_MSG);
                _hasError = _hasError || field;
            } else if (!val.trim().length) {
                showFieldError(field, VAL_FAIL_MSG);
                _hasError = _hasError || field;
            }

            if (_hasError) {
                errField = _hasError;
            } else {
                field.removeAttribute('style');
            }
        });

        if (rmaType.every(el => !el.checked)) {
            showMessage(VAL_FAIL_MSG, 'error');
            errField = errField || rmaType[0];
            rmaRow.style.border = errBorder;
        } else {
            rmaRow.removeAttribute('style');
        }

        if (!errField) {
            messageBox.classList.remove('show');
        }

        return errField;
    }

    /**
     *
     * @param error
     * @param field
     * @returns {boolean}
     */
    const showFieldError = (field, error) => {
        showMessage(error, 'error');
        field.style.border = errBorder;
        return false
    }

    /**
     *
     * @param message
     * @param type
     */
    const showMessage = (message, type) => {
        messageBox.innerHTML = `<span class="${type}">${message}</span>`;
        messageBox.classList.add('show');
        // $('.ajax-container').html('<span class="' + type + '">' + message + '</span>').css('opacity', '0').show().fadeTo(1000, 1);
    }


    init();
}


// function isVisible(el) {
//     return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
// }
//


    // if ($('#rma-plus').length) {
    //     $('#rma-plus').on('click', function(){
    //         if (!$('#rma-prod-2').is(":visible")) {
    //             $('#rma-prod-2').slideDown(200);
    //             return false;
    //         }
    //         if (!$('#rma-prod-3').is(":visible")) {
    //             $('#rma-prod-3').slideDown(200);
    //             $(this).hide();
    //             return false;
    //         }
    //     });
    // }
// RMA Form
//     $('#btnSubmit').on('click', function(e) {
//         e.preventDefault();
//         e.stopPropagation();
//         if($("input[name='contact']").val() === '') {
//             alert("Please specify Contact person!");
//             $("input[name='contact']").focus();
//             return(false);
//         }
//         if($("input[name='phone']").val() === '') {
//             alert("Please specify contact Phone!");
//             $("input[name='phone']").focus();
//             return(false);
//         }
//         if($("input[name='email']").val() === '') {
//             alert("Please specify Email address!");
//             $("input[name='email']").focus();
//             return(false);
//         }
//         if(!isEmail($("input[name='email']").val())) {
//             alert("Please specify real Email address!");
//             $("input[name='email']").focus();
//             return(false);
//         }
//         if($("input[name='invoice_1']").val() === '' && $("input[name='invoice_2']").val() === '' && $("input[name='invoice_3']").val() === '') {
//             alert("Please enter Invoice / PO!");
//             $("input[name='invoice_1']").focus();
//             return(false);
//         }
//         if($("input[name='partnumber_1']").val() === '' && $("input[name='partnumber_2']").val() === '' && $("input[name='partnumber_3']").val() === '') {
//             alert("Please enter Part Number!");
//             $("input[name='partnumber_1']").focus();
//             return(false);
//         }
//         if($("input[name='serial_1']").val() === '' && $("input[name='serial_2']").val() === '' && $("input[name='serial_3']").val() === '') {
//             alert("Please enter Serial Number!");
//             $("input[name='serial_1']").focus();
//             return(false);
//         }
//         if($("textarea[name='problem0']").val() === '') {
//             alert("Please shortly describe Problem!");
//             $("textarea[name='problem0']").focus();
//             return(false);
//         }
//         var retVal = false;
//         for (var i=0; i<$("input[name='rma_type']").length; i++) {
//             if ($("input[name='rma_type']")[i].checked) { retVal = true; }
//         }
//         if (!retVal) {
//             alert("Please specify RMA TYPE!");
//             return(false);
//         }
//         if($("input[name='u_name']").val() === '') {
//             alert("Please specify Your Name!");
//             $("input[name='u_name']").focus();
//             return(false);
//         }
//         $('#rmaSubmit').html('<div class="spinner-loader">Loading…</div> Please wait...');
//         $('#rmaForm').submit();
//         return (false);
//     });




